var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYouTube = function SvgYouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9 21.8L18.1 17.4C17.9 17.3 17.6 17.5 17.6 17.7V26.3C17.6 26.6 17.9 26.7 18.1 26.6L26.9 22.4C27.1 22.3 27.1 22 26.9 21.8Z",
    fill: "#266BEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0H4C1.8 0 0 1.8 0 4V40C0 42.2 1.8 44 4 44H40C42.2 44 44 42.2 44 40V4C44 1.8 42.2 0 40 0ZM38 26.7C38 30.4 35 33.3 31.4 33.3H12.6C8.9 33.3 6 30.3 6 26.7V17.3C6 13.6 9 10.7 12.6 10.7H31.3C35 10.7 37.9 13.7 37.9 17.3V26.7H38Z",
    fill: "#266BEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "white"
  })))));
};
export default SvgYouTube;